import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AmortizationBalanceListView from './AmortizationBalanceList';

const PolicyView = () => (
  <Routes>
    <Route path="amortization-balance/*" element={<AmortizationBalanceListView />} />
    <Route index element={<Navigate to="amortization-balance" replace />} />
  </Routes>
);

export default PolicyView;
